export default function Box({ minX, maxX, minY, maxY }) {
    this.belongsToBox = ({x, y}) => minX < x && x < maxX && minY < y && y < maxY;
}